export { AppConsts } from '@axilla/axilla-shared';
